export const formatsDistributableToDcm = ["ExportableImage", "ExportableVideo", "AnimatedBanner", "ExportableFastLoadingAnimatedBanner", "ExportableFastLoadingCrossScreenBanner"]

export const formatsDistributableToFlashtalking = ["ExportableImage", "ExportableFastLoadingAnimatedBanner", "ExportableFastLoadingCrossScreenBanner", "ExportableVideo"]

export const formatsDistributableToFacebook = ["FacebookPhotoAdPost", "FacebookVideoAdPost", "FacebookCarouselAdPost"]

export const formatsDistributableToFlashtalkingLabels = ["Image", "Animated HTML", "Interactive HTML", "Video"]

export const accessTokenExpirationDuration = 10 * 60 * 1000
